<template>
    <el-dialog
        :visible.sync="invoiceVisible"
        width="468px"
        title="发票信息"
        :show-close="false"
        :before-close="handleClose"
        :close-on-click-modal="false"
        :lock-scroll="true"
        class="invoiceInfoBox"
    >
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-width="120px"
            label-position="right"
            status-icon
        >
            <el-form-item label="发票抬头:" prop="status">
                <el-radio-group v-model="formData.status" @change="changeStatus">
                    <el-radio :label="'0'">个人</el-radio>
                    <el-radio :label="'1'">单位</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="发票类型:"> 电子发票 </el-form-item>
            <el-form-item
                label="姓名:"
                prop="userName"
                v-if="formData.status === '0'"
                key="userName"
            >
                <el-input v-model="formData.userName"></el-input>
            </el-form-item>
            <el-form-item
                label="单位名称:"
                prop="companyName"
                v-if="formData.status === '1'"
                key="companyName"
            >
                <el-input v-model="formData.companyName"></el-input>
            </el-form-item>
            <el-form-item
                label="纳税人识别号:"
                prop="invoiceNum"
                v-if="formData.status === '1'"
                key="invoiceNum"
            >
                <el-input v-model="formData.invoiceNum"></el-input>
            </el-form-item>
            <el-form-item
                label="联系电话:"
                prop="phone"
                key="phone"
                v-if="formData.status === '0'"
            >
                <el-input v-model="formData.phone"></el-input>
            </el-form-item>
            <el-form-item
                label="联系电话:"
                prop="companyPhone"
                key="companyPhone"
                v-if="formData.status === '1'"
            >
                <el-input v-model="formData.companyPhone"></el-input>
            </el-form-item>
            <el-form-item class="btnBox">
                <el-button
                    type="danger"
                    @click="submitForm('formData')"
                    sizi="mini"
                    >提交</el-button
                >
                <el-button @click="handleClose" sizi="mini">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import { isvalidPhone } from "@/utils/validate";
export default {
    props: {
        invoiceVisible: {
            type: Boolean,
            default: false,
        },
        invoiceInfo: {
            type: Object,
            default() {},
        },
        remoteInvoiceClose: Function,
    },
    watch: {
        invoiceVisible: {
            handler(newValue) {
                //重新打开弹窗 -- 关闭form校验
                if (this.$refs.formData !== undefined) this.$refs['formData'].resetFields();
                if (newValue) {
                    this.formData.status = this.invoiceInfo.titleType;
                    this.formData.userName = this.invoiceInfo.titleType == '0' ? this.invoiceInfo.titleName : '';
                    this.formData.companyName = this.invoiceInfo.titleType == '0' ? '' : this.invoiceInfo.titleName;
                    this.formData.phone = this.invoiceInfo.titleType == '0' ? this.invoiceInfo.phoneNumber : '';
                    this.formData.companyPhone = this.invoiceInfo.titleType == '0' ? '' :  this.invoiceInfo.phoneNumber;
                    this.formData.invoiceNum = this.invoiceInfo.titleType == '0' ? '' :  this.invoiceInfo.taxNumber;
                }
            },
        },
    },
    data() {
        var validPhone = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入手机号码"));
            } else if (!isvalidPhone(value)) {
                callback(new Error("请填写正确的手机号码"));
            } else {
                callback();
            }
        };
        return {
            rules: {
                userName: [
                    //prop的值
                    { required: true, message: "请输入姓名", trigget: "blur" },
                ],
                status: [
                    {
                        required: true,
                        type: "string",
                        message: "请选择发票抬头",
                        trigget: "blur",
                    },
                ],
                companyName: [
                    {
                        required: true,
                        type: "string",
                        message: "请输入单位名称",
                        trigget: "blur",
                    },
                ],
                invoiceNum: [
                    {
                        required: true,
                        type: "string",
                        message: "请输入纳税人识别号",
                        trigget: "blur",
                    },
                ],
                phone: [
                    { required: true, validator: validPhone, trigger: "blur" },
                ],
                companyPhone: [
                    { required: true, validator: validPhone, trigger: "blur" },
                ],
            },
            formData: {
                status: null,
                userName: "",
                companyName: "",
                phone: "",
                companyPhone: "",
                invoiceNum: "",
            },
        };
    },
    methods: {
        //往父组件传发票信息
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit("sendWriteInvoiceInfo", this.formData);
                    this.handleClose();
                    this.$nextTick(() => {
                        this.$refs['formData'].resetFields();
                    });
                } else {
                    return false;
                }
            });
        },
        //切换发票抬头
        changeStatus(){
            if(this.formData.status == '0'){
                this.formData.companyName = '';
                this.formData.companyPhone = '';
                this.formData.invoiceNum = '';
            }else {
                this.formData.userName = '';
                this.formData.phone = '';
            }
        },
        //关闭dialog
        handleClose() {
            this.remoteInvoiceClose();
        },
    },
};
</script>

<style>
.el-dialog__body {
    padding: 20px;
}
.btnBox .el-form-item__content {
    margin-left: 0 !important;
    text-align: center;
}
.invoiceInfoBox .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #b21f27;
}
.invoiceInfoBox .el-checkbox__input.is-focus .el-checkbox__inner,
.invoiceInfoBox .el-checkbox__inner:hover {
    border-color: #b21f27;
}
.invoiceInfoBox .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #b21f27;
    background: #b21f27;
}
.invoiceInfoBox .el-radio__inner:hover {
    border-color: #b21f27;
}
.invoiceInfoBox .el-radio__input.is-checked + .el-radio__label {
    color: #b21f27;
}
.invoiceInfoBox .el-radio__input.is-checked .el-radio__inner {
    border-color: #b21f27;
    background: #b21f27;
}
.invoiceInfoBox .el-input__inner:hover,
.invoiceInfoBox .el-input__inner:focus {
    border-color: #b21f27;
}
.invoiceInfoBox .el-dialog__header span {
    font-size: 24px;
}
.invoiceInfoBox .el-dialog__header {
    background: #fff1f2;
}
</style>
